export class GoodReceipt {
    artikel_id: number;
    charge: string;
    mhd: Date;
    lagerplatz_id_ziel: number;
    menge: number;
    bestellung_extern_id: number;
}
